.page {
  background: #fff;
  padding: var(--page-pad-y) var(--page-pad-x);
  max-width: 1280px;
  margin: 0 auto;
  container-type: inline-size;
  container-name: pdp;
}

.loading { padding: 80px; text-align: center; color: var(--color-ink-soft); }

.top {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
  gap: clamp(24px, 5vw, 64px);
}

.galleryCol { min-width: 0; }

.info {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}

.title {
  font-family: var(--font-display);
  font-weight: 400;
  font-size: var(--fs-2xl);
  line-height: 1.1;
  letter-spacing: 0;
  margin: 0;
}

.ratingRow {
  display: flex;
  align-items: center;
  gap: 12px;
}

.reviewLink {
  font-size: 0.85rem;
  color: var(--color-ink-soft);
  text-decoration: underline;
}

.sku {
  font-size: 0.85rem;
  color: var(--color-ink-soft);
}

.metaRow {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.videoChip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px 4px 6px;
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--color-ink);
  text-decoration: none;
  transition: border-color 120ms ease, color 120ms ease, background 120ms ease;
}

.videoChip:hover {
  border-color: var(--color-ink);
  background: var(--color-bone);
}

.videoIcon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--color-ink);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.shortDesc {
  margin: 0;
  font-size: 1rem;
  line-height: 1.55;
  color: var(--color-ink-soft);
  font-weight: 400;
  letter-spacing: 0.005em;
  max-width: 56ch;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}

.label {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  color: var(--color-ink);
}

.colorRow {
  display: flex;
  gap: 8px;
  align-items: baseline;
  flex-wrap: wrap;
}

.colorName {
  font-size: 0.78rem;
  font-weight: 500;
  letter-spacing: 0.12em;
  color: var(--color-ink-soft);
}

.priceLevelTag {
  display: inline-block;
  background: rgba(243, 154, 46, 0.18);
  color: var(--color-ember-dark);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding: 4px 10px;
  margin-top: -4px;
}

.availability {
  font-size: 0.85rem;
  color: var(--color-ink-soft);
  margin-top: 4px;
}

.sizeRow { display: flex; gap: 8px; }

.sizeChip {
  min-width: 48px;
  padding: 8px 12px;
  border: 1px solid rgba(0, 0, 0, 0.18);
  background: #fff;
  font: inherit;
  font-size: 0.85rem;
  letter-spacing: 0.04em;
  cursor: pointer;
  text-transform: uppercase;
}

.sizeChipActive {
  border-color: var(--color-ink);
  background: var(--color-ink);
  color: #fff;
}

.fitting {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #f5f2ee;
  padding: 10px 14px;
  cursor: pointer;
  font: inherit;
  font-size: 0.78rem;
  color: var(--color-ink);
}

.fitting strong { letter-spacing: 0.1em; }

.price {
  font-family: var(--font-display);
  font-weight: 400;
  font-size: var(--fs-2xl);
  margin-top: 4px;
}

.financing {
  font-size: 0.85rem;
  color: var(--color-ink);
  background: var(--color-bone);
  padding: 8px 12px;
  display: inline-block;
}

.financingMuted { color: var(--color-ink-soft); }

.qtyRow {
  display: flex;
  align-items: stretch;
  gap: 16px;
}

.qtyBox {
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.18);
  padding: 0 4px;
}

.addBtn {
  flex: 1;
  background: var(--color-ember) !important;
  color: #111 !important;
  font-weight: 700 !important;
  letter-spacing: 0.14em !important;
  padding: 12px 24px !important;
}

.wishlist {
  align-self: flex-end;
  font-size: 0.78rem;
  letter-spacing: 0.16em;
  color: var(--color-ink-soft);
  text-transform: uppercase;
  text-decoration: underline;
}

.tagline {
  text-align: center;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: var(--fs-2xl);
  letter-spacing: -0.01em;
  line-height: 1.15;
  margin: clamp(40px, 5vw, 56px) auto 14px;
  max-width: 22ch;
  color: var(--color-ink);
}

.body {
  max-width: 64ch;
  margin: 0 auto;
  font-size: var(--fs-base);
  line-height: 1.65;
  color: var(--color-ink-soft);
  text-align: center;
  font-weight: 400;
  letter-spacing: 0.005em;
}

.detailSplit {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(280px, 1fr);
  gap: clamp(28px, 4vw, 56px);
  align-items: start;
  margin-top: clamp(28px, 4vw, 56px);
  padding: 0 4px;
}

.detailLeft, .detailRight { min-width: 0; }

/* Container query on the PDP page itself: the side-by-side gallery
   + info layout collapses based on actual available space, not the
   raw viewport. iPad mini landscape (1133px) keeps the split, Pixel
   7 landscape (915px) flips, narrow desktop windows flip, all from
   the same rule. */
@container pdp (max-width: 880px) {
  .top { grid-template-columns: 1fr; gap: clamp(20px, 4vw, 32px); }
  .detailSplit {
    grid-template-columns: 1fr;
    gap: clamp(20px, 4vw, 32px);
    margin-top: clamp(20px, 4vw, 32px);
  }
  /* Specs panel reads better above the long-form attributes when
     the layout is single-column. */
  .detailRight { order: -1; }
}
